import { memo } from 'react';
import classnames from 'classnames';
import { Tab as ReactTabsTab } from 'react-tabs';

import style from './tab.module.less';

import type { TabProps } from 'react-tabs';
import type { ReactTabsMemoComponent } from 'ui-components/components/tabs/tabs-types';

export const Tab: ReactTabsMemoComponent<TabProps> = memo(({ children, className, selectedClassName, ...rest }) => (
  <ReactTabsTab
    className={classnames(style.tab, className)}
    selectedClassName={classnames(style['selected-tab'], selectedClassName)}
    tabIndex='0'
    {...rest}
  >
    {children}
  </ReactTabsTab>
));

Tab.displayName = 'Tab';
Tab.tabsRole = 'Tab';
